import { isNullOrUndefined } from 'util';
import moment from "moment";

export function getEta(cart) {

    return {
        singleDispatch: getSingleDispatchEta(cart),
        multipleDispatch: getMultipleDispatchEta(cart),
    };
}


function getSingleDispatchEta(cart) {

    if (cart == null) {
        return null;
    }

    if (cart.lines == null || cart.lines.length <= 0) {
        return null;
    }

    var singleDispatchEta;
    
    var eta = null;
    if (cart.proposedEtaDate) {
        singleDispatchEta = `(estimated dispatch by ${moment(cart.proposedEtaDate).format("DD MMMM YYYY")})`;
    }

    var itemsWithBackorder = 0;


    var hasPastDueDate = false;

    for (var i = 0; i < cart.lines.length; i++) {
        var stockInfo = getStockInfo(cart, cart.lines[i].product, cart.lines[i].quantity, cart.lines[i].stockLevel);

        if (stockInfo != null && stockInfo.willTriggerBackorder) {

            if (eta == null) {
                eta = stockInfo.eta;
            } else if (stockInfo.eta > eta) {
                eta = stockInfo.eta;
            }

            itemsWithBackorder += 1;

            if (stockInfo.eta == null || moment(stockInfo.eta).isBefore()) {
                hasPastDueDate = true;
            }
        }
    }

    if (itemsWithBackorder > 0) {

        singleDispatchEta = "";

        if (eta != null) {
            singleDispatchEta = `(estimated dispatch by ${moment(eta).format("DD MMMM YYYY")})`;
        } else if (eta == null) {
            singleDispatchEta = `(ETA to be confirmed)`;
        }
    }

    if (hasPastDueDate) {
        singleDispatchEta = `(ETA to be confirmed)`;
    }
   
    return singleDispatchEta;

}

function getMultipleDispatchEta(cart) {

    if (cart == null) {
        return null;
    }

    if (cart.lines == null || cart.lines.length <= 0) {
        return null;
    }

    var eta = null;
    var multipleDispatchEta;
           
    var itemsWithBackorder = 0;

    for (var i = 0; i < cart.lines.length; i++) {
        var stockInfo = getStockInfo(cart, cart.lines[i].product, cart.lines[i].quantity, cart.lines[i].stockLevel);

        if (stockInfo != null && stockInfo.willTriggerBackorder) {

            itemsWithBackorder += 1;

            if (eta == null) {
                eta = stockInfo.eta;
            } else if (stockInfo.eta < eta) {
                eta = stockInfo.eta;
            }
        }
    }

    if (itemsWithBackorder != cart.lines.length && cart.proposedEtaDate) {
        multipleDispatchEta = `(estimated first dispatch by ${moment(cart.proposedEtaDate).format("DD MMMM YYYY")})`;
    } else if (itemsWithBackorder == cart.lines.length && eta != null) {
        multipleDispatchEta = `(estimated first dispatch by ${moment(eta).format("DD MMMM YYYY")})`;
    } else {

        if (eta != null) {
            multipleDispatchEta = `(estimated first dispatch by ${moment(eta).format("DD MMMM YYYY")})`;
        } else {
            multipleDispatchEta = `(ETA to be confirmed)`;
        }
        
    }

    return multipleDispatchEta;

}


export function getStockInfo(cart, product, quantity, stockLevel = null) {
    if (isNullOrUndefined(cart) || isNullOrUndefined(cart.supplyLocation)) {
        return null;
    }

    var className;
    var text;
    var eta;
    var isDiscontinued = false;
    var locationQuantity = 0;

    var currentLocationDetails;
    if (cart) {

        if (!product) {
            return null;
        }

        if (!product.stockAvailability) {
            return null;
        }

        var currentLocation = product.stockAvailability.filter((location) => {
            return cart.supplyLocation == location.locationName;
        });

        if (isNullOrUndefined(currentLocation[0]) || isNullOrUndefined(currentLocation[0].status)) {
            return null;
        }

        currentLocationDetails = currentLocation[0];

        switch (currentLocation[0].status) {
            case "InStock":
                className = "in-stock";
                text = "In Stock";                
                break;
            case "SpecialOrderOnly":
                className = "out-stock";
                text = "Special Order";
                break;
            case "LowStock":
                className = "low-stock";
                text = "Only " + currentLocation[0].amount + " left";
                break;
            case "OutOfStock":
                className = "out-stock";
                text = "Out of stock";
                break;
            case "Discontinued":
                className = "low-stock";
                text = "Discontinued " + currentLocation[0].amount + " left";
                isDiscontinued = true;
                break;
        }

    }

    text = <div style={{"position": "inherit", "font-size": "12px", "color": "#ff8100", "background-color": "#ffffff", "border-color": "#ffffff" }} className="warning-block" data-tip='This product will cause a backorder.'>
                <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" fill="currentColor" class="bi bi-exclamation-circle-fill" viewBox="0 0 16 16">
                    <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM8 4a.905.905 0 0 0-.9.995l.35 3.507a.552.552 0 0 0 1.1 0l.35-3.507A.905.905 0 0 0 8 4zm.002 6a1 1 0 1 0 0 2 1 1 0 0 0 0-2z" />
                </svg>
        <strong> { text } </strong>
            </div>;


    var willTriggerBackorder = false;
    var issue = null;

    if (currentLocationDetails) {

        let minimumQuantity = currentLocationDetails.minimumQuantity;

        if (currentLocationDetails.status == 'Discontinued' && currentLocationDetails.amount < quantity) {
            issue = `${product.stockcode} is discontinued. You can only order discontinued stock if stock levels is greater than 0`;
            willTriggerBackorder = true;
        }

        if (currentLocationDetails.status == 'Discontinued' && currentLocationDetails.amount > 0 && currentLocationDetails.amount < quantity) {
            issue = `${product.stockcode} is discontinued. Only current stock levels (${currentLocationDetails.amount}) can be ordered`;
            willTriggerBackorder = true;     
            locationQuantity = currentLocationDetails.amount;
        }

        if (currentLocationDetails.status == 'LowStock' && currentLocationDetails.amount < quantity) {
            willTriggerBackorder = true;
            locationQuantity = currentLocationDetails.amount;
        }

        if (currentLocationDetails.status == 'SpecialOrderOnly') {
            if (minimumQuantity && minimumQuantity > quantity) {
                issue = `Stock ${product.stockcode} has a minimiun quantity of ${minimumQuantity}. You cannot order less than ${minimumQuantity}`;
            } else if (minimumQuantity && (quantity % minimumQuantity != 0)) {
                issue = `Stock ${product.stockcode} is a special order item and must be ordered in multiples of ${minimumQuantity}. Please update order quantity`;
            }

            if (stockLevel != null && stockLevel < quantity) {
                willTriggerBackorder = true;
            }
            
        }

        if (currentLocationDetails.status == 'OutOfStock') {
            willTriggerBackorder = true;
        }

        //eta = "22/04/2022";
        eta = currentLocationDetails.eta;

        if (currentLocationDetails.status == "InStock" && stockLevel != null && stockLevel < quantity) {

            className = "low-stock";
            text = "Only " + stockLevel + " left";
            willTriggerBackorder = true;
            locationQuantity = stockLevel;
        }

    }

    return {
        type: className,
        text: text,
        willTriggerBackorder,
        issue,
        eta,
        isDiscontinued,
        locationQuantity
    }
}


export function getErrorCollection(cart) {
    var errorCollection = [];
    for (var i = 0; i < cart.lines.length; i++) {
        var line = cart.lines[i];
        var stockInfo = getStockInfo(cart, line.product, line.quantity, line.stockLevel);
        if (stockInfo && stockInfo.issue != null) {
            errorCollection.push({
                line: line,
                stockInfo: stockInfo
            });
        }
    }

    return errorCollection;
}

export const getUnitLabel = (amount, unit, unitPlural) => {
    if (amount > 1) {
        return unitPlural ? unitPlural : "Units";
    } else {
        return unit ? unit : "Unit";
    }
}

export const getStock = (cart, stockAvailability) => {
    let stock;

    if (cart && stockAvailability) {
        stock = stockAvailability.find((location) => {
            return cart.supplyLocation == location.locationName && location.status == "SpecialOrderOnly";
        });

        return stock;
    }

}
export const calculateInputValue = (minimumQuantity, inputVal) => {
    if (inputVal) {
        return minimumQuantity > inputVal ? minimumQuantity : inputVal
    }
    return ''
}